import { Component, OnInit, Input } from '@angular/core';
import { GfTitleService } from '../../../../services/core.title.service';

/**
 * Project admin homepage host — the "homepage type" toggle plus, when Custom is selected, the
 * self-contained <wiki-container> (View/Edit/Versions of the project's ProjectHome wiki page).
 * The container owns all wiki behaviour; this host only supplies configuration.
 */
@Component({
  selector: 'project-admin-homepage',
  template: require('./project.admin.homepage.html')
})
export class ProjectAdminHomepageComponent implements OnInit {
  @Input() project: any;
  @Input() projectMenu: any;
  @Input() isProjectAdmin: any;
  @Input() useCustomSplash: any;

  constructor(private titleService: GfTitleService) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.project.name, 'Admin', 'Homepage');
  }

  get isCustom(): boolean {
    const v = this.useCustomSplash;
    return v === 'Y' || v === 'y' || v === true || v === 'true' || v === 1 || v === '1';
  }
}
